import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import sourceflowEnums from "@/sourceflow.enums";

import { router } from "@/routes";


export { default } from 'pages/blog'


export async function getStaticProps() {
    const global = (await Global()).toJson();

    const blogs = (await Collection(`downloads`))
        .filter(post => {
            // Downloads value id
            return post?.blog_category.en.includes("cc63315d-fbad-46e1-b6e4-1f6ebac0d9cb");
        })
        .orderBy(['published_date.en'], ['desc'])
        .getItems()
    const blog_tags = (await Collection(`blog_tags`)).getItems()
    const blog_category = (await Collection(`blog_category`)).getItems()

    const routerKey = "downloads";

    return {
        props: {
            global,
            blogs,
            blog_category,
            blog_tags,
            meta: {
                title: "Downloads | Tradewind Subs",
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            },
        },
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search